<div class="column image-column">
	<img [src]="selectedEquipment?.imageUrl" width="250px" height="250px" alt="Cargando...">
</div>

<div class="column">
	<h3 class="title red">{{ equipment[0]?.subClass }}</h3>
	<ul *ngIf="showCalifications" class="calif-list">
		<li>
			<span class="red-text">C.I.</span> Calificación de instalación
		</li>
		<li>
			<span class="red-text">C.O.</span> Calificación de operación
		</li>
		<li style="padding-bottom: 1em">
			<span class="red-text">C.F.</span> Calificación de desempeño
		</li>
	</ul>
	<ul class="link-list">
		<li *ngFor="let e of equipment; let i = index">
			<a (click)="selectItem(i)">{{ e?.name }}</a>
		</li>
	</ul>
</div>